import { Navigate } from 'react-router-dom';
import { USER_QUERY_KEY } from '../constants/query';
import { Roles } from '../constants/role';
import useQueryData from '../queries/useQueryData';
import { userRoleSelector } from '../selectors/user';

const SuperAdminGuard = ({ children, redirectTo }) => {
  const userRole = useQueryData(USER_QUERY_KEY, userRoleSelector);

  if (userRole !== Roles.superAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default SuperAdminGuard;
